import React from 'react';

import { useUserInfo } from '@src/hooks/userInfo';
import { isImpersonate, stopImpersonate } from '@src/utils/jwtHelpers';

import './impersonate-bar.scss';

const ImpersonateBar = () => {
    const agent = useUserInfo();

    const handleOnClick = React.useCallback(() => {
        stopImpersonate();
        window.location.reload();
    }, []);

    if (!isImpersonate()) {
        return null;
    }

    return (
        <div className="impersonate-bar">
            <span>View portal as an agent. Agent ID: { agent.agentCode }, Producer ID: { agent.producerId }</span>
            <button
                type="button"
                className="ml-button-primary"
                title="Stop Masquerade"
                onClick={handleOnClick}
            >
                Stop Masquerade
            </button>
        </div>
    );
};

export default ImpersonateBar;
